<div class="mu-pt5">
  <mu-spinner [variant]="'page'">
    <h5 class="ion-text-center">{{ 'auth-page.logging-in' | translate}}</h5>
  </mu-spinner>
</div>
